/**
 * @desc Router routes
 * @author Jooger <iamjooger@gmail.com>
 * @date 1 Dec 2017
 */

'use strict'

import Login from '@/components/Login'
import PrivateConsultationPage from '@/components/private_consultation_page'
import Error403 from '@/components/Error/403'
import Error404 from '@/components/Error/404'
import Error500 from '@/components/Error/500'


export const constantRoutes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录',
      hidden: true,
      fullscreen: true
    }
  },
  {
    path: '/PrivateConsultationPage',
    name: 'PrivateConsultationPage',
    component: PrivateConsultationPage,
    meta: {
      title: '问诊',
      hidden: true,
      fullscreen: true
    }
  },
  {
    path: '/403',
    name: 'Error403',
    component: Error403,
    meta: {
      hidden: true,
      fullscreen: true
    }
  },
  {
    path: '/404',
    name: 'Error404',
    component: Error404,
    meta: {
      hidden: true,
      fullscreen: true
    }
  },
  {
    path: '/500',
    name: 'Error500',
    component: Error500,
    meta: {
      hidden: true,
      fullscreen: true
    }
  }
]




// WEBPACK FOOTER //
// ./src/router/routes.js